import { BaseModel } from "sjs-base-model";

export default class ResultModel extends BaseModel {
    readonly ok: Boolean = false;
    readonly info: String = "";

    constructor(data: Partial<ResultModel>) {
        super();

        this.update(data);
    }
}
